import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AddDeliverySiteComponentService {

    apiUrl = environment.apiUrl;

    constructor(private httpClient: HttpClient) { }

    getCountries() {
        let url = this.apiUrl + '/getCountry';
        return this.httpClient.get(url);
    }
    getCustomerNames(countryCode) {
        let url = this.apiUrl + '/getCustomer';
        return this.httpClient.get(url, {
            params: {
              CountryCode: countryCode,
            }
          });
    }
    addDeliverySiteService(deliverySite: any, primaryContactWithCountryCode: string, sendReminderFlag: string) {
        let url = this.apiUrl + '/AddDeliverySiteService';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };

        // Old payload before Haulier changes
        /* let postData = JSON.stringify({
            "CountryId": deliverySite.CountryId,
            "Status": deliverySite.Status,
            "CreatedBy": deliverySite.CreatedBy,
            "CustomerId": deliverySite.CustomerId,
            "DeliverySite": deliverySite.DeliverySiteName,
            "City": deliverySite.City,
            "PrimaryContact": deliverySite.PrimaryContact,
            "AddressLine2": deliverySite.AddressLine2,
            "UpdatedBy": deliverySite.UpdatedBy,
            "AddressLine1": deliverySite.AddressLine1,
            "SubscriberEmailAddress": deliverySite.SubscriberEmailAddress,
            "DeliveryPostalCode": deliverySite.DeliveryPostalCode,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "CarrierEmailAddress": deliverySite.CarrierEmailAddress,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "State": null,
            "CustomerName": deliverySite.CustomerName,
            "BillingReference": deliverySite.BillingReference,
            "ApprovalStage": deliverySite.ApprovalStage,       
        }); */

        // New payload after Haulier changes
        let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySite": deliverySite.DeliverySiteName,
            "CustomerName": deliverySite.CustomerName,
            "SubscriberEmailAddress": deliverySite.SubscriberEmailAddress,
            "CarrierEmailAddress": deliverySite.CarrierEmailAddress,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "BillingReference": deliverySite.BillingReference,
            "PrimaryContact": primaryContactWithCountryCode,
            "AddressLine1": deliverySite.AddressLine1,
            "AddressLine2": deliverySite.AddressLine2,
            "DeliveryPostalCode": deliverySite.DeliveryPostalCode,
            "State": null,
            "City": deliverySite.City,
            "CreatedBy": deliverySite.CreatedBy,
            "CountryId": deliverySite.CountryId,
            "Status": deliverySite.Status,
            "ApprovalStage": deliverySite.ApprovalStage,
            "UpdatedBy": deliverySite.UpdatedBy,
            "HaulierEmailId": null,
            "SecondaryHaulierEmailId": null,
            "NotifyHaulier": "FALSE",
            "SendReminderFlag": sendReminderFlag
        });

        return this.httpClient.post(url, postData, httpOptions).pipe();
    }
    updateDeliverySite(deliverySite: any, primaryContactWithCountryCode: string, sendReminderFlag: string) {
        let url = this.apiUrl + '/UpdateDeliverySite';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        // Old payload before Haulier changes
        /* let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySiteName": deliverySite.DeliverySiteName,
            "SubscriberEmailAddress": deliverySite.SubscriberEmailAddress,
            "CarrierEmailAddress": deliverySite.CarrierEmailAddress,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "PrimaryContact": deliverySite.PrimaryContact,
            "AddressLine1": deliverySite.AddressLine1,
            "AddressLine2": deliverySite.AddressLine2,
            "BillingReference": deliverySite.BillingReference,
            "DeliveryPostalCode": deliverySite.DeliveryPostalCode,
            "State": null,
            "City": deliverySite.City,
            "CountryId": deliverySite.CountryId,
            "Status": deliverySite.Status,
            "ApprovalStage": deliverySite.ApprovalStage,
            "UpdatedBy": deliverySite.UpdatedBy,
            "UpdatedOn": deliverySite.UpdatedOn
        }); */

        // New payload after Haulier changes
        let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySiteName": deliverySite.DeliverySiteName,
            "SubscriberEmailAddress":deliverySite.SubscriberEmailAddress,
            "CarrierEmailAddress": deliverySite.CarrierEmailAddress,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "PrimaryContact": primaryContactWithCountryCode,
            "AddressLine1": deliverySite.AddressLine1,
            "AddressLine2": deliverySite.AddressLine2,
            "BillingReference": deliverySite.BillingReference,
            "DeliveryPostalCode": deliverySite.DeliveryPostalCode,
            "State": null,
            "City": deliverySite.City,
            "CountryId": deliverySite.CountryId,
            "Status": deliverySite.Status,
            "ApprovalStage": deliverySite.ApprovalStage,
            "UpdatedBy": deliverySite.UpdatedBy,
            "UpdatedOn": deliverySite.UpdatedOn,
            "HaulierEmailId": null,
            "SecondaryHaulierEmailId": null,
            "NotifyHaulier": "FALSE",
            "SendReminderFlag": sendReminderFlag
        });
        
        // let postData = JSON.stringify(deliverySite);
        return this.httpClient.post(url, postData, httpOptions).pipe();
    }
    updateDepotStatus(deliverySite: any) {
        let url = this.apiUrl + '/UpdateDepotStatus';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySite": deliverySite.DeliverySite,
            "UserStatus": deliverySite.ApprovalStatus,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "Type": deliverySite.Type,
            "CountryCode": deliverySite.CountryId,
            "UpdatedBy": deliverySite.UpdatedBy,
            "UpdatedOn": deliverySite.UpdatedOn
        }
        );
        return this.httpClient.post(url, postData, httpOptions).pipe();
    }
    updateJDEStatus(deliverySite: any) {
        let url = this.apiUrl + '/UpdateJDEStatus';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySite": deliverySite.DeliverySite,
            "UserStatus" :  deliverySite.ApprovalStatus,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "Type": deliverySite.Type,
            "CountryCode": deliverySite.CountryId,
            "UpdatedBy": deliverySite.UpdatedBy,
            "UpdatedOn": deliverySite.UpdatedOn
        }
        );
        return this.httpClient.post(url, postData, httpOptions).pipe();
    }
    updateDeliverySiteStatus(deliverySite: any) {
        let url = this.apiUrl + '/UpdateDeliverySiteStatus';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        let postData = JSON.stringify({
            "CustomerId": deliverySite.CustomerId,
            "DeliverySite": deliverySite.DeliverySite,
            "CountryCode": deliverySite.CountryId,
            "ApprovalStage": deliverySite.ApprovalStage,
            "UpdatedOn": deliverySite.UpdatedOn,
            "CustomerName": deliverySite.CustomerName
        });
        return this.httpClient.post(url, postData, httpOptions).pipe();
    }

    emailService(key: string, countryCode: string, deliverySite: any, primaryContactWithCountryCode: string, fieldsChanged: string, sendReminderFlag: string) {
        let url = this.apiUrl + '/EmailService';
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };

        let postData = JSON.stringify({
            "Key": key,
            "CountryCode": countryCode,
            "CustomerName": deliverySite.CustomerName,
            "DeliverySite": deliverySite.DeliverySiteName,
            "DepotAddressNumber": deliverySite.DepotAddressNumber,
            "JdeAddressNumber": deliverySite.JdeAddressNumber,
            "PrimaryContact": primaryContactWithCountryCode,
            "SubscriberEmailAddress": deliverySite.SubscriberEmailAddress,
            "CarrierEmailAddress": deliverySite.CarrierEmailAddress,
            "BillingReference": deliverySite.BillingReference,
            "AddressLine1": deliverySite.AddressLine1,
            "AddressLine2": deliverySite.AddressLine2,
            "DeliveryPostalCode": deliverySite.DeliveryPostalCode,
            "City": deliverySite.City,
            "CountryId": deliverySite.CountryId,
            "ZipCode": deliverySite.DeliveryPostalCode,
            "Status": deliverySite.Status,
            "FieldChange": fieldsChanged,
            "SendReminderFlag": sendReminderFlag
        });
        return this.httpClient.post(url, postData, httpOptions).pipe();
    }
    
}